// extracted by extract-css-chunks-webpack-plugin
module.exports = {"G-night":"_1qay_","G-img-wrap":"RIwV0","is-irregular":"_36fr6"};